import { deepmerge } from '@mui/utils'
import { defaultLightTheme, defaultDarkTheme } from 'react-admin'
import { grey, blue } from '@mui/material/colors'

const baseStyle = {
  components: {
    RaMenuItemLink: {
      styleOverrides: {
        root: {
          '&.RaMenuItemLink-active': {
            borderLeft: '5px solid',
            borderColor: blue[500],
            backgroundColor: grey[300]
          }
        }
      }
    },
    MuiTextField: {
      defaultProps: {
        variant: 'standard'
      }
    },
    MuiSelect: {
      defaultProps: {
        variant: 'standard'
      },
      styleOverrides: {
        root: {
          minWidth: '100px'
        }
      }
    }
  }
}

const lightTheme = deepmerge(defaultLightTheme, {
  ...baseStyle,
  palette: {
    primary: {
      main: '#4b65d5'
    },
    background: {
      default: grey[50]
    }
  }
})

const darkTheme = deepmerge(defaultDarkTheme, {
  ...baseStyle,
  components: {
    ...baseStyle.components,
    RaMenuItemLink: {
      styleOverrides: {
        root: {
          '&.RaMenuItemLink-active': {
            borderLeft: '5px solid #4f3cc9',
            backgroundColor: grey[800]
          }
        }
      }
    }
  }
})

export { lightTheme, darkTheme }
